module.exports = __webpack_public_path__ + "72e19cbb0e38c6773a7751156752cec4.woff";